export function titelize(string) {
  return string ? string[0].toUpperCase() + string.slice(1) : ''
}

export function isString(string) {
  return typeof string === 'string'
}
